module.exports = __webpack_public_path__ + "public/adminIcons/total-listings-graph.png?efafbbc7";